namespace GeniuzPOS.InitialData {
    export class PsCorperateMessageColumns {
        static columnsKey = 'InitialData.PsCorperateMessage';
    }
}
